var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.singleLine
    ? _c(
        "el-tooltip",
        { attrs: { content: _vm.content, placement: "top" } },
        [_vm._t("default")],
        2
      )
    : _c(
        "el-tooltip",
        { attrs: { placement: "top" } },
        [
          _c("div", {
            attrs: { slot: "content" },
            domProps: { innerHTML: _vm._s(_vm.content) },
            slot: "content",
          }),
          _vm._t("default"),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }